import { io } from "socket.io-client";

// Connect once and export the socket instance globally
export const socket = io(process.env.REACT_APP_SOCKET_URL, {
  transports: ["websocket"],
  reconnection: true,
  reconnectionAttempts: 5,
  reconnectionDelay: 2000,
});
